import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Login from "./components/users/LoginUsers";
import Dashboard from "./components/users/Dashboard";
import LoginClients from "./components/clients/LoginClients";
import SearchResults from "./components/clients/components/searchProducts/SearchResults";
import PasswordRecovery from "./components/general/PasswordRecovery";
import ChangePassword from "./components/userLogin/ChangePassword";
import PrivateRoute from "./components/general/PrivateRoute";
import UserDetails from "./components/users/UserDetails";
import CreateUser from "./components/users/CreateUser";
import Products from "./components/inventories/products/Products";
import RegisterClients from "./components/clients/RegisterClients";
import AddProduct from "components/inventories/products/AddProduct";
import ProductDetails from "components/inventories/products/ProductDetails";
import Categories from "components/inventories/categories/Categories";
import AddCategory from "components/inventories/categories/AddCategory";
import CategoryDetails from "components/inventories/categories/CategoryDetails";
import { SizeList } from "components/sizes";
import { AddSizes } from "components/sizes/AddSizes";
import { SizeDetails } from "components/sizes/SizeDetails";
import { SizeEdit } from "components/sizes/SizeEdit";
import AddPromotion from "components/promotions/AddPromotion";
import PromotionDetails from "components/promotions/PromotionDetails";
import EditPromotion from "components/promotions/EditPromotion";
import MainPage from "components/clients/MainPage";
import { OrderDetails } from "components/orders/OrderDetails";
import Reports from "components/reports/Reports";
import AllCategories from "components/clients/components/categories/AllCategories";
import AllPromotions from "components/clients/components/promotions/AllPromotions";
import ProductDetailsClients from "components/clients/components/products/ProductDetailsClients";
import ProfilePage from "components/clients/components/profile/ProfilePage";
import CartPage from "components/clients/components/sellSection/CartPage";
import CheckoutPage from "components/clients/components/sellSection/CheckoutPage";
import { Favorites } from "components/clients/components/profile/profileFavorites/Favorites";
import { UserOrders } from "components/clients/components/profile/profileOrders/UserOrders";
import PostPurchasePage from "components/clients/components/postPurchase/PostPurchasePage";
import NewestProductsPage from "components/clients/components/newestProducts/NewestProductsPage";
import AboutUs from "components/clients/components/about/AboutUs";
import Contact from "components/clients/components/contact/Contact";
import TermsAndConditions from "components/clients/components/termsAndConditions/TermsAndConditions";
import PrivacyPolicy from "components/clients/components/privacyPolicy/PrivacyPolicy";
import FAQ from "components/clients/components/faq/FAQ";

const ChangePasswordWrapper = () => {
  const location = useLocation();
  return (
    <ChangePassword
      email={(location.state as any)?.email}
      verificationCode={(location.state as any)?.verificationCode}
    />
  );
};

const AppRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/adminLogin" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/users/:id"
          element={
            <PrivateRoute>
              <UserDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/users/create"
          element={
            <PrivateRoute>
              <CreateUser />
            </PrivateRoute>
          }
        />
        <Route
          path="/inventories/products"
          element={
            <PrivateRoute>
              <Products />
            </PrivateRoute>
          }
        />
        <Route
          path="/inventories/categories"
          element={
            <PrivateRoute>
              <Categories />
            </PrivateRoute>
          }
        />
        <Route
          path="/inventories/products/add"
          element={
            <PrivateRoute>
              <AddProduct />
            </PrivateRoute>
          }
        />
        <Route
          path="/inventories/categories/add"
          element={
            <PrivateRoute>
              <AddCategory />
            </PrivateRoute>
          }
        />
        <Route
          path="/inventories/sizes"
          element={
            <PrivateRoute>
              <SizeList />
            </PrivateRoute>
          }
        />
        <Route
          path="/inventories/sizes/add"
          element={
            <PrivateRoute>
              <AddSizes />
            </PrivateRoute>
          }
        />
        <Route
          path="/inventories/sizes/details"
          element={
            <PrivateRoute>
              <SizeDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/inventories/sizes/edit"
          element={
            <PrivateRoute>
              <SizeEdit />
            </PrivateRoute>
          }
        />
        <Route
          path="/promotions/add"
          element={
            <PrivateRoute>
              <AddPromotion />
            </PrivateRoute>
          }
        />
        <Route
          path="/products/:id"
          element={
            <PrivateRoute>
              <ProductDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/promotions/:id"
          element={
            <PrivateRoute>
              <PromotionDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/promotions/:id/edit"
          element={
            <PrivateRoute>
              <EditPromotion />
            </PrivateRoute>
          }
        />
        <Route
          path="/inventories/categories/:id"
          element={
            <PrivateRoute>
              <CategoryDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/inventories/orders/details"
          element={
            <PrivateRoute>
              <OrderDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <PrivateRoute>
              <Reports />
            </PrivateRoute>
          }
        />
        <Route path="/recuperar-contrasena" element={<PasswordRecovery />} />
        <Route path="/change-password" element={<ChangePasswordWrapper />} />
        <Route path="/" element={<MainPage />} />
        <Route path="/login" element={<LoginClients />} />
        <Route path="/register" element={<RegisterClients />} />
        <Route path="/all-categories" element={<AllCategories />} />
        <Route path="/all-promotions" element={<AllPromotions />} />
        <Route
          path="/product-details/:id"
          element={<ProductDetailsClients />}
        />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/profile" element={<ProfilePage />}>
          <Route path="favorites" element={<Favorites />} />
          <Route path="orders" element={<UserOrders />} />
        </Route>
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/order-confirmation" element={<PostPurchasePage />} />
        <Route path="/nuevos" element={<NewestProductsPage />} />
        <Route path="/sobre-nosotros" element={<AboutUs />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/faq" element={<FAQ />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
